/** Convertit une URL vidéo en URL lisible par <video> ou <iframe>. */
export function videoEmbedUrl(
  url: string,
  source?: "file" | "youtube" | "vimeo" | string,
): string | null {
  if (!url) return null;
  if (source === "file" || url.startsWith("/assets/")) return url;

  const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]+)/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;

  const vimeo = url.match(/(?:vimeo\.com\/|player\.vimeo\.com\/video\/)(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;

  if (url.includes("youtube.com/embed/") || url.includes("player.vimeo.com/video/")) {
    return url;
  }

  return url;
}

export function isLocalVideoUrl(url: string, source?: string): boolean {
  return source === "file" || url.startsWith("/assets/");
}
